module.exports = {
  "pc.activity.ended": "Ended",
  "pc.activity.join_now": "Join now",
  "pc.activity.new_year_opening_bonus": "New Year's Market Opening Bonus Waiting for You",
  "pc.activity.ongoing": "Ongoing",
  "pc.activity.special_offers": "Special Offers",
  "pc.activity.view_event": "View Event",
  "pc.agency.agent_level": "Agent Level",
  "pc.agency.agent_level1": "First level agent",
  "pc.agency.agent_level2": "Secondary agent",
  "pc.agency.agent_level3": "Third level agent",
  "pc.agency.all_members": "All Members",
  "pc.agency.click_link_to_register": "Method 2: Click the link to register",
  "pc.agency.commision_share": "Commission Share",
  "pc.agency.commision_transfer": "Commission Transfer",
  "pc.agency.commission_balance": "Commission Balance",
  "pc.agency.commission_withdrawal": "Commission Withdrawal",
  "pc.agency.copied": "Copied",
  "pc.agency.copy_link": "Copy Link",
  "pc.agency.deferred_fee_commission": "Deferred Fee Commission",
  "pc.agency.deferred_fee_details": "Deferred Fee Details",
  "pc.agency.enter_referral_code_when_registering": "Method 3: Enter the referral code when registering",
  "pc.agency.first_deposit_amount": "First Deposit Amount",
  "pc.agency.friend_single_recharge": "Friends' Single Recharge",
  "pc.agency.from_agent_account": "From Agent Account",
  "pc.agency.invite_friends_scanning_qr": "Method 1: Invite friends to register by scanning the QR code",
  "pc.agency.invite_friends_to_register": "Invite friends to register using the following three methods",
  "pc.agency.level1_membership": "Level 1 Membership",
  "pc.agency.level2_membership": "Level 2 Membership",
  "pc.agency.level3_membership": "Level 3 Membership",
  "pc.agency.management_fee_commission": "Management Fee Commission",
  "pc.agency.management_fee_details": "Management Fee Details",
  "pc.agency.member_level": "Member Level",
  "pc.agency.member_name": "Member Name",
  "pc.agency.member_recharge_reward_details": "Member Recharge Reward Details",
  "pc.agency.membership": "Membership",
  "pc.agency.membership_number": "Membership Number",
  "pc.agency.mobile_number": "Mobile Number",
  "pc.agency.my_commission": "My Commission",
  "pc.agency.my_membership": "My Membership",
  "pc.agency.my_promotions": "My Promotions",
  "pc.agency.no_recharge_membership": "No Recharge Membership",
  "pc.agency.number": "Number",
  "pc.agency.only_one_person_can_use_it": "Only one person can use it",
  "pc.agency.person": "Person",
  "pc.agency.please_enter_correct_amount": "Please enter the correct amount",
  "pc.agency.please_enter_transfer_amount": "Please enter the transfer amount",
  "pc.agency.please_enter_withdrawal_amount": "Please enter the withdrawal amount",
  "pc.agency.please_enter_withdrawal_password": "Please enter your withdrawal password",
  "pc.agency.profit_share_details": "Profit Share Details",
  "pc.agency.profit_sharing": "Profit Sharing",
  "pc.agency.recharge_membership": "Recharge Membership",
  "pc.agency.scan_qr_code_to_register": "Method 1: Scan the QR code to register",
  "pc.agency.status": "Status",
  "pc.agency.to_principal_account": "To Principal Account",
  "pc.agency.today_member": "Today Member",
  "pc.agency.total_deposit": "Total Deposit",
  "pc.agency.total_withdrawal": "Total Withdrawal",
  "pc.agency.transfer": "Transfer",
  "pc.agency.transfer_amount": "Transfer Amount",
  "pc.agency.withdrawal_starts_from_100yuan": "Withdrawal starts from 100 yuan",
  "pc.agency.withdrawal_transfer": "Withdrawal Transfer",
  "pc.agency.you_can_withdraw": "You can withdraw",
  "pc.allhkstock.all_us_stocks": "All US Stocks",
  "pc.allhkstock.change": "Change",
  "pc.allhkstock.code": "Code",
  "pc.allhkstock.code_name_abbreviation": "Code/Name/Abbreviation",
  "pc.allhkstock.highest_price": "Highest Price",
  "pc.allhkstock.latest_price": "Latest Price",
  "pc.allhkstock.lowest_price": "Lowest Price",
  "pc.allhkstock.market_center": "Market Center",
  "pc.allhkstock.name": "Name",
  "pc.allhkstock.opening_price": "Opening Price",
  "pc.allhkstock.rate_of_change": "Rate of Change",
  "pc.allhkstock.us_stock_market": "US Stock Market",
  "pc.allhkstock.us_stock_market_time": "US Stock Market Time:",
  "pc.capital.amount_to_be_deposited": "Amount to be deposited",
  "pc.capital.bank": "Bank Management",
  "pc.capital.bank_account": "Account Name: ",
  "pc.capital.bank_branch": "Bank Branch",
  "pc.capital.bank_card": "Bank Card: ",
  "pc.capital.bank_name": "Bank Name",
  "pc.capital.bind_bank_card": "Bind Bank Card",
  "pc.capital.card_number": "card number",
  "pc.capital.daily_limit_automatic_deposits": "Daily limit for automatic deposits",
  "pc.capital.decimal_amount_must_match_displayed_system": "(The decimal amount must match the amount displayed on the system)",
  "pc.capital.deposit_address": "Deposit Address",
  "pc.capital.deposit_channel_digital_currency_usdt": "Deposit Channel: Digital Currency - USDT (TRC20)",
  "pc.capital.deposit_desc1": "Please take a screenshot of the transfer and send it to our online customer service or dedicated customer service for confirmation to request a deposit.",
  "pc.capital.deposit_desc2": "Please wait 1-15 minutes for the funds to be credited to your account after a certain number of confirmations have been received across the entire network.",
  "pc.capital.deposit_qr_code": "Deposit QR Code",
  "pc.capital.digital_currency_usdt_ins1": "1. We are not responsible for duplicate payments or deposits with modified amounts that are not credited.",
  "pc.capital.digital_currency_usdt_ins2": "2. The platform uses the amount received as the basis for renewal: amount received = amount transferred - amount transferred.",
  "pc.capital.digital_currency_usdt_ins3": "3. Scan the QR code or copy the address to deposit. Only TRC20-USDT is accepted.",
  "pc.capital.friendly_reminder": "Friendly Reminder",
  "pc.capital.friendly_reminder_desc1": "1. Some transfers include decimals to help the system quickly determine the amount of the deposit. Otherwise, the funds will arrive the next day. For example, if you submit $100 and the system displays $100.02, simply transfer $100.02 and the funds will be credited to your account.",
  "pc.capital.friendly_reminder_desc2": "2. If the funds are not deposited within 10 minutes, please contact our online customer service or dedicated customer service representative.",
  "pc.capital.myaccount": "My Account",
  "pc.capital.not_match": "The two passwords you entered do not match",
  "pc.capital.or": "or",
  "pc.capital.pay_before": "Pay Before",
  "pc.capital.payment_countdown": "Payment Countdown",
  "pc.capital.payment_time": "Payment Time",
  "pc.capital.please": "Please",
  "pc.capital.please_contact_customer_service_for_latest_bank_card": "Please contact online customer service to obtain the latest bank card.",
  "pc.capital.please_enter_bank_address": "Please enter your bank address",
  "pc.capital.please_enter_verification_code": "Please enter your verification code",
  "pc.capital.please_enter_your_account_holder_name": "Please enter your account holder's name",
  "pc.capital.please_enter_your_bank_branch": "Please enter the branch of the account-opening bank",
  "pc.capital.please_enter_your_bank_card_number": "Please enter your bank card number",
  "pc.capital.please_enter_your_confirmation_password": "Please enter your confirmation password",
  "pc.capital.please_enter_your_id": "Please enter your ID number",
  "pc.capital.please_enter_your_password": "Please enter your password",
  "pc.capital.please_enter_your_real_name": "Please enter your real name",
  "pc.capital.please_fill_correct_amount": "Please fill in the correct amount",
  "pc.capital.please_pay": "Please pay",
  "pc.capital.recharge": "Recharge",
  "pc.capital.recharge_ac_name": "Account Name:",
  "pc.capital.recharge_amt": "Recharge Amount : ",
  "pc.capital.recharge_amt_placeholder": "Please fill in the recharge amount",
  "pc.capital.recharge_approve": "I have transferred funds. Request a top-up.",
  "pc.capital.recharge_bank_addr": "Bank Address:",
  "pc.capital.recharge_cancel": "Cancel transfer",
  "pc.capital.recharge_channel": "Recharge Channel",
  "pc.capital.recharge_deliver": "deliver",
  "pc.capital.recharge_dollar": "US dollar",
  "pc.capital.recharge_exchange_amt": "Exchange amount:",
  "pc.capital.recharge_exchange_fee": "Exchange Fee:",
  "pc.capital.recharge_exchange_rate": "Exchange rate:",
  "pc.capital.recharge_exchange_ratio": "USD:RMB:=",
  "pc.capital.recharge_full": "Recharge fully",
  "pc.capital.recharge_ins": "Recharge Instructions:",
  "pc.capital.recharge_ins1": "1. Please do not keep the old card for transfer, as it will cause the recharge to be unable to work.",
  "pc.capital.recharge_ins2": "2. Please use your own account to transfer funds to the following account via mobile phone/computer/bank.",
  "pc.capital.recharge_ins3": "3. After the transfer is successful, click 'I have transferred, apply for recharge' and the platform will confirm the transfer.",
  "pc.capital.recharge_ins4": "4. The transfer amount must be consistent with the system. If there is a decimal, it must be rounded up, otherwise it will arrive the next day.",
  "pc.capital.recharge_instruction": "Recharge Instruction : ",
  "pc.capital.recharge_instruction1": "Do not keep the old card, or you won’t be able to recharge.",
  "pc.capital.recharge_instruction2": "Be sure to use the deposit card specified by the brokerage firm.",
  "pc.capital.recharge_next": "Next Step",
  "pc.capital.recharge_next_step": "Get a real-time deposit card and transfer money via mobile phone/computer/bank",
  "pc.capital.recharge_open": "Open Payment channel",
  "pc.capital.recharge_pay_amt": "Payment amount:",
  "pc.capital.recharge_pay_copy": "Copy",
  "pc.capital.recharge_rmb": "RMB",
  "pc.capital.recharge_success": "The recharge application is successful, please complete the subsequent operations as soon as possible and contact customer service",
  "pc.capital.recharge_tip": "Kind tips:",
  "pc.capital.recharge_tip1": "If the deposit is not made within 10 minutes, please contact online customer service or dedicated customer service.",
  "pc.capital.recharge_type": "Recharge Type:",
  "pc.capital.recharge_validity": "Validity Period",
  "pc.capital.recharge_yuan": "¥",
  "pc.capital.starting_from_rmb": "Starting from RMB",
  "pc.capital.topup_over_10000_yuan": "Top up over 10,000 yuan",
  "pc.capital.unable_to_access_bank_card_repeatly": "Unable to access bank card repeatedly",
  "pc.capital.verify_yuor_gx": "Please verify your Gxpay ID before confirming your withdrawal",
  "pc.capital.withdraw": "Withdraw",
  "pc.capital.withdraw.bankcard_popup_cancel_button": "Cancel",
  "pc.capital.withdraw.bankcard_popup_confirm_button": "Confirm",
  "pc.capital.withdraw.bankcard_popup_content": "Please set up a bank card before withdrawing funds",
  "pc.capital.withdraw.bankcard_popup_title": "Prompt",
  "pc.capital.withdraw.second_withdraw_popup_content_cancel_button": "Transfer to ShiShiBao",
  "pc.capital.withdraw.second_withdraw_popup_content_confirm_button": "Continue to withdraw cash",
  "pc.capital.withdraw.second_withdraw_popup_content_popup_title": "Friendly reminder",
  "pc.capital.withdraw.second_withdraw_popup_first_content": "Transfer to ShiShiBao, earn every 8 hours",
  "pc.capital.withdraw.second_withdraw_popup_second_content": "Stock trading during market hours and financial management during market hours, making money anytime\nIn and out anytime, real-time payment, and annualized rate of return",
  "pc.capital.withdraw1": "Please use your own ( ",
  "pc.capital.withdraw2": ") name of the bank card withdrawal!",
  "pc.capital.withdraw_Ac": "Please select the withdrawal account",
  "pc.capital.withdraw_ac_balance": "Account Balance:",
  "pc.capital.withdraw_amt": "Withdrawal amount:",
  "pc.capital.withdraw_amt_plh": "Minimum withdrawal amount: 100 yuan",
  "pc.capital.withdraw_change_pw": "Change withdrawal password",
  "pc.capital.withdraw_confirm": "Confirm withdrawal",
  "pc.capital.withdraw_exchange_rate": "Exchange rate:",
  "pc.capital.withdraw_gx_plh": "Please enter your Gxpay ID",
  "pc.capital.withdraw_gx_verified": "Verified",
  "pc.capital.withdraw_pw": "Withdrawal password:",
  "pc.capital.withdraw_pw_plh": "Please enter the withdrawal password",
  "pc.capital.withdraw_type": "Withdrawal Methods:",
  "pc.capitalcommon.log_first": "Please log in first",
  "pc.capitalcommon.please_read_agreement": "Please read the agreement first",
  "pc.common.mobile_format_error": "The mobile phone number format is incorrect",
  "pc.dealbuy.enter_buy_price": "Please enter the purchase price",
  "pc.dealbuy.enter_buy_qty": "Please enter the purchase quantity",
  "pc.dealbuy.enter_valid_code": "Please enter a valid security code",
  "pc.dealbuy.securitycode_exsist": "This security already exists",
  "pc.dealbuy.securitycode_not_exsist": "The security code does not exist",
  "pc.dealsell.enter_sell_price": "Please enter the selling price",
  "pc.dealsell.enter_sell_qty": "Please enter the selling quantity",
  "pc.dealsell.securitycode_not_exsist": "The security code does not exist",
  "pc.download.android_classic_version": "Android Classic Version",
  "pc.download.android_professional_version": "Android Professional Version",
  "pc.download.android_upgrate_free_version": "Android Upgrade-Free Version",
  "pc.download.apple_classic_version": "Apple Classic Version",
  "pc.download.apple_tf_version": "Apple TF Version (Anti-Block)",
  "pc.download.apple_upgrate_free_version": "Apple Upgrade-Free Version",
  "pc.download.downlod_desc1": "Scan the QR code and click “View in App Store” to install and open TestFlight.",
  "pc.download.downlod_desc2": "Scan the QR code again, then click the \"Start Test\" - \"Accept\" - \"Install\" button under the Golden Bull Hong Kong Stocks icon to use it.",
  "pc.download.downlod_note": "Note: TF stands for TestFlight, an official Apple distribution model.",
  "pc.download.windows_desktop": "Windows Desktop",
  "pc.entrust.enter_sell_price": "Please enter the additional amount",
  "pc.entrust.enter_sell_qty": "Please enter the additional amount",
  "pc.entrust.securitycode_not_exsist": "Please enter the withdrawal amount",
  "pc.financefund.enter_amount_incorect": "The amount entered is incorrect",
  "pc.footer.about_us": "About Us",
  "pc.footer.beginner_guide": "Beginner's Guide",
  "pc.footer.business_hours": "Business Hours",
  "pc.footer.company_profile": "Company Profile",
  "pc.footer.company_qualification": "Company Qualifications",
  "pc.footer.contact_us": "Contact Us",
  "pc.footer.faq": "FAQ",
  "pc.footer.help_center": "Help Center",
  "pc.footer.investment_risky": "(Investment is risky, please be cautious when entering the market)",
  "pc.footer.money_with_promotion": "Earn Money with Promotion",
  "pc.footer.registration_agreement": "Registration Agreement",
  "pc.footer.service_hotline": "Service Hotline",
  "pc.footer.statutory_holidays": "Statutory Holidays",
  "pc.forgetpass.confirm": "Confirm",
  "pc.forgetpass.enter_sms_verification_code": "Please enter the SMS verification code",
  "pc.forgetpass.enter_your_card_number": "Please enter your card number",
  "pc.forgetpass.enter_your_new_password": "Please enter your new password",
  "pc.forgetpass.enter_your_real_name": "Please enter your real name",
  "pc.forgetpass.get_verification_code": "Get Verification Code",
  "pc.forgetpass.id_number": "ID number",
  "pc.forgetpass.name": "Name",
  "pc.forgetpass.new_pw_again": "Please enter your new password again",
  "pc.forgetpass.not_match": "The two passwords you entered do not match",
  "pc.forgetpass.reenter_your_new_password": "Re-Enter your new password",
  "pc.friendcoupon.details": "Details",
  "pc.friendcoupon.expiration_date": "Expiration Date",
  "pc.friendcoupon.gift_date": "Gift Date",
  "pc.friendcoupon.instructions_for_use": "Instructions for use",
  "pc.friendcoupon.promotional_qr_code": "Promotional QR Code/Link",
  "pc.header.about_us": "About Us",
  "pc.header.activity_zone": "Activity",
  "pc.header.app_download": "Download",
  "pc.header.apply_for_funding": "Funding",
  "pc.header.bull_stock_diagnosis": "Bull Stock Diagnosis",
  "pc.header.front_page": "Home",
  "pc.header.line1": "Line1",
  "pc.header.line2": "Line2",
  "pc.header.line3": "Line3",
  "pc.header.line_switch": "Line Switch",
  "pc.header.login": "Login",
  "pc.header.logout": "Logout",
  "pc.header.real_transaction": "Long Trading",
  "pc.header.register": "Register",
  "pc.header.short_trade": "Short Trading",
  "pc.header.us_stock_account": "USStock",
  "pc.header.us_stock_market": "Market",
  "pc.header.want_to_promote": "I want to promote",
  "pc.help.beginners_guide": "Beginner's guide",
  "pc.help.capital_allocation_guide": "Capital Allocation Guide",
  "pc.help.registration_agreement": "Registration Agreement",
  "pc.help.trading_rules": "Trading Rules",
  "pc.home.100thousand_capital_allocation_actual_profit": "100,000 RMB of capital allocation and 35,000 RMB of profit",
  "pc.home.10thousand_capital_allocation_actual_profit": "10,000 real funds profit 2,000",
  "pc.home.12million_capital_allocation_238000_actual_capital_profit": "1.28 million yuan of capital allocation and 238,000 yuan of actual capital profit",
  "pc.home.150thousand_capital_allocation_26000_actual_profit": "150,000 RMB of capital allocation and 26,000 RMB of actual capital profit",
  "pc.home.150thousand_capital_allocation_actual_profit": "150,000 RMB of capital allocation and 27,900 RMB of profit from real trading",
  "pc.home.1million_capital_allocation_156000_actual_capital_profit": "1.5 million RMB in capital allocation and 156,000 RMB in actual trading profit",
  "pc.home.1million_capital_allocation_158000_actual_capital_profit": "1.3 million RMB in capital allocation and 158,000 RMB in actual trading profit",
  "pc.home.1million_capital_allocation_238000_actual_capital_profit": "1.4 million yuan of capital allocation and 238,000 yuan of actual capital profit",
  "pc.home.1million_capital_allocation_actual_capital_profit": "1.5 million yuan of capital allocation and 405,000 yuan of actual capital profit",
  "pc.home.2million_capital_allocation_actual_capital_profit": "2 million yuan of capital allocation and 720,000 yuan of actual capital profit",
  "pc.home.3million_capital_allocation_355000_actual_capital_profit": "3.2 million RMB in capital allocation and 355,000 RMB in actual trading profit",
  "pc.home.3million_capital_allocation_423000_actual_capital_profit": "3.2 million yuan of capital allocation and 423,000 yuan of actual capital profit",
  "pc.home.3million_capital_allocation_624000_actual_capital_profit": "3.2 million yuan of capital allocation and 624,000 yuan of actual capital profit",
  "pc.home.3million_capital_allocation_actual_capital_profit": "3 million yuan of capital allocation and 690,000 yuan of actual capital profit",
  "pc.home.400thousand_capital_allocation_actual_profit": "400,000 RMB of capital allocation and 140,000 RMB of actual capital profit",
  "pc.home.4million_capital_allocation_actual_profit": "4.2 million yuan in capital allocation and 856,000 yuan in actual capital profit",
  "pc.home.50thousand_capital_allocation_actual_profit": "The actual capital of 50,000 yuan is profitable 7,600 yuan",
  "pc.home.5million_capital_allocation_actual_capital_profit": "5 million yuan of capital allocation and 860,000 yuan of actual capital profit",
  "pc.home.600thousand_capital_allocation_actual_profit": "600,000 RMB in capital allocation and 204,000 RMB in actual trading profit",
  "pc.home.60thousand_capital_allocation_12800_actual_profit": "60,000 RMB of capital allocation and 12,800 RMB of profit",
  "pc.home.60thousand_capital_allocation_actual_profit": "60,000 RMB real capital profit of 9,000 RMB",
  "pc.home.800thousand_capital_allocation_actual_profit": "800,000 RMB of capital allocation and actual capital profit of 198,400 RMB",
  "pc.home.880thousand_capital_allocation_actual_profit": "880,000 RMB of capital allocation and 228,800 RMB of actual capital profit",
  "pc.home.USD": "USD",
  "pc.home.agent_qq": "Agent QQ:",
  "pc.home.alipay": "Alipay",
  "pc.home.announcement": "Announcement",
  "pc.home.app_download": "App Download",
  "pc.home.baidu": "Baidu",
  "pc.home.bank_of_china": "Bank of China",
  "pc.home.capital_allocation_actual_profit": "170,000 RMB in capital allocation and 17,000 RMB in actual capital profit",
  "pc.home.capital_allocation_actual_trading_profit": "610,000 RMB in capital allocation and 48,800 RMB in actual trading profit",
  "pc.home.china_merchant_securities": "China Merchants Securities",
  "pc.home.china_minsheng_bank": "China Minsheng Bank",
  "pc.home.citic_securitits": "CITIC Securities",
  "pc.home.click_to_contact_customer_service": "Click to contact customer service",
  "pc.home.customer_service_qq": "Customer Service QQ:",
  "pc.home.daniu_customer_service": "Taurus Customer Service",
  "pc.home.day_capital": "Day",
  "pc.home.east_fortune": "East Fortune",
  "pc.home.exculusive_gift_for_new_members": "Exclusive Gift for New Members",
  "pc.home.first_deposit_bonus": "First Deposit Bonus",
  "pc.home.free": "Free",
  "pc.home.fund_guarantee": "Fund Guarantee",
  "pc.home.fund_guarantee_desc": "Third-party oversight of funds, dedicated funds for specific purposes",
  "pc.home.funds_are_managed_by_three_parties": "Funds are managed by three parties/insurance is double guaranteed/real trading is fully realized",
  "pc.home.galaxy_securities": "Galaxy Securities",
  "pc.home.gf_securities": "GF Securities",
  "pc.home.go_to_you": "Go to you",
  "pc.home.haitong_securities": "Haitong Securities",
  "pc.home.huatai_securities": "Huatai Securities",
  "pc.home.independent_account": "Independent Account",
  "pc.home.interest_free_capital": "Interest Free",
  "pc.home.interest_rates_low": "Interest Rates as Low as",
  "pc.home.live_trading_professional_certified_brand": "Live Trading, Professional and Secure, Certified Brand",
  "pc.home.login_now": "LogIn Now",
  "pc.home.maximum_margin": "Maximum Margin",
  "pc.home.million_dollar": "Million Dollars",
  "pc.home.minimum_allocation_amount": "Minimum allocation amount",
  "pc.home.month_capital": "Month",
  "pc.home.more": "More",
  "pc.home.news": "News",
  "pc.home.no_interest_charged": "No interest charged",
  "pc.home.online_customer_service": "Online Customer Service",
  "pc.home.partners": "Partners",
  "pc.home.phone": "Phone",
  "pc.home.ping_an_securities": "Ping An Securities",
  "pc.home.professional_service": "Professional service",
  "pc.home.professional_service_desc": "Customer experience is paramount",
  "pc.home.profit": "profit",
  "pc.home.qq_customer_service": "QQ Customer Service",
  "pc.home.quick_withdrawals": "Quick withdrawals",
  "pc.home.quick_withdrawals_desc": "Lightning withdrawals, funds received in as little as three minutes",
  "pc.home.real_capital_profit": "50,000 RMB real capital profit of 8,000 RMB",
  "pc.home.real_money_and_profit": "60,000 RMB in real money and a profit of 16,200 RMB",
  "pc.home.real_trading": "Real trading",
  "pc.home.real_trading_desc": "100% live trading, synchronized with stock market data",
  "pc.home.recently_registered_successfully": "Recently registered successfully",
  "pc.home.recharge": "Recharge",
  "pc.home.register_as_member": "Register as a member",
  "pc.home.register_now": "Register Now",
  "pc.home.registration_bonus": "Registration Bonus",
  "pc.home.return": "Return",
  "pc.home.revene_share": "Revenue Sharing",
  "pc.home.stable_and_efficient": "Stable and Efficient",
  "pc.home.successfully_registered_today": "Successfully Registered Today",
  "pc.home.ten_thousands": "10000",
  "pc.home.today_recharge": "Recharge today",
  "pc.home.trading_master": "Trading Master",
  "pc.home.vip_capital": "VIP Capital",
  "pc.home.want_to_allocate_funds": "I want to allocate funds",
  "pc.home.week_capital": "Week",
  "pc.home.yuan": "yuan",
  "pc.information.already_set": "Already Set",
  "pc.information.bank_card_binding": "Bank Card Binding",
  "pc.information.bound": "Bound",
  "pc.information.certification": "Certification",
  "pc.information.change_nick_name": "Change Nickname",
  "pc.information.edit": "Edit",
  "pc.information.enter_real_name": "Please enter your real name",
  "pc.information.link_email": "Link Email",
  "pc.information.link_mobile_number": "Bind mobile phone number",
  "pc.information.login_password": "Login Password",
  "pc.information.mobile_format_error": "The mobile number format is incorrect",
  "pc.information.mobile_phone_binding": "Mobile Phone Binding",
  "pc.information.nick_name": "Nickname",
  "pc.information.not_certified": "Not Certified",
  "pc.information.not_set": "not set",
  "pc.information.please_enter_bank_address": "Please enter the bank address",
  "pc.information.please_enter_confirm_pw": "Please enter your confirmation password",
  "pc.information.please_enter_new_pw": "Please enter your new password",
  "pc.information.please_enter_verification_code": "Please enter the verification code",
  "pc.information.please_enter_your_account_holder_name": "Please enter your account holder's name",
  "pc.information.please_enter_your_bank_card_number": "Please enter your bank card number",
  "pc.information.please_enter_your_email": "Please enter your email",
  "pc.information.please_enter_your_id": "Please enter your ID number",
  "pc.information.please_enter_your_mobile_number": "Please enter your mobile number",
  "pc.information.please_enter_your_nickname": "Please enter your nickname",
  "pc.information.please_enter_your_password": "Please enter your password",
  "pc.information.pw_not_matched": "The two passwords you entered do not match",
  "pc.information.security_settings": "Security Settings",
  "pc.information.set_up": "set up",
  "pc.information.unbound": "Unbound",
  "pc.information.withdrawal_password": "Withdrawal Password",
  "pc.login.do_not_have_an_account": "Don't have an account",
  "pc.login.enter_your_image_verification_code": "Please enter your image verification code",
  "pc.login.enter_your_password": "Please enter your password",
  "pc.login.enter_your_phone_number": "Please enter your phone number",
  "pc.login.forgot_your_password": "Forgot your password",
  "pc.login.image_code_wrong": "Image verification code is incorrect",
  "pc.login.register_now": "Register Now",
  "pc.login.user_login": "User Login",
  "pc.myaccount.account_balance": "Account Balance",
  "pc.myaccount.administrative_fees": "Administrative Fees",
  "pc.myaccount.agency_account": "Agency Account",
  "pc.myaccount.agent_commission": "Agent Commission",
  "pc.myaccount.amount_rmb": "Amount (RMB)",
  "pc.myaccount.annualized_rate_return": "Annualized Rate of Return",
  "pc.myaccount.available_balance": "Available Balance",
  "pc.myaccount.available_funds": "Available Funds",
  "pc.myaccount.bill": "Bill",
  "pc.myaccount.cancel": "Cancel",
  "pc.myaccount.cash_back": "Cash Back",
  "pc.myaccount.complete_information": "Complete Information",
  "pc.myaccount.confirm": "Confirm",
  "pc.myaccount.cumulative_return": "Cumulative Return",
  "pc.myaccount.current_assets": "Current Assets",
  "pc.myaccount.deposit_now": "Deposit Now",
  "pc.myaccount.details": "Details",
  "pc.myaccount.disable_and_not_remind_this_week": "Disable and do not remind this week",
  "pc.myaccount.earn_money_with_stock_trading_annualized_return": "Earn money instantly with stock trading and financial management. Annualized return",
  "pc.myaccount.end_date": "End Date",
  "pc.myaccount.financing_account": "Financing Account",
  "pc.myaccount.first_deposit_gift_list": "First Deposit Gift List",
  "pc.myaccount.friend_cash_coupons": "Friend Cash Coupons",
  "pc.myaccount.full_details": "Full Details",
  "pc.myaccount.fund_operations": "Fund Operations",
  "pc.myaccount.funding_details": "Funding Details",
  "pc.myaccount.funds": "Funds",
  "pc.myaccount.go_to_friend_cash_coupons": "Go to Friend Cash Coupons",
  "pc.myaccount.hello_danniu_securities_member": "Hello, Golden Bull Securities member",
  "pc.myaccount.holiday_treasure": "Holiday Treasure",
  "pc.myaccount.last_login_time": "Last Login Time",
  "pc.myaccount.loan_details": "Loan Details",
  "pc.myaccount.margin_trading_now": "Margin Trading Now",
  "pc.myaccount.my_cash_coupons": "My Cash Coupons",
  "pc.myaccount.new_member_trading_bonus_list": "New Member Trading Bonus List",
  "pc.myaccount.next_page": "Next Page",
  "pc.myaccount.past_8hour_return": "Past 8-hour Return",
  "pc.myaccount.please_enter_your_id": "Please enter your ID number",
  "pc.myaccount.please_enter_your_real_name": "Please enter your real name",
  "pc.myaccount.please_verify_your_account_to_activate": "Please verify your account to activate",
  "pc.myaccount.previous_page": "Previous Page",
  "pc.myaccount.real_name_verification": "Real-Name Verification",
  "pc.myaccount.regular_treasure": "Regular Treasure",
  "pc.myaccount.risk_control_notification": "Risk Control Notification",
  "pc.myaccount.search": "Search",
  "pc.myaccount.shishi_bao": "Shishi Bao",
  "pc.myaccount.sign_in": "Sign-in",
  "pc.myaccount.start_date": "Start Date",
  "pc.myaccount.to": "To",
  "pc.myaccount.total_assets": "Total Assets",
  "pc.myaccount.total_frozen_margin": "Total Frozen Margin",
  "pc.myaccount.trading_inquiry": "Trading Inquiry",
  "pc.myaccount.transfer_from_shishibao": "Transfer from ShiShiBao",
  "pc.myaccount.transfer_in": "Transfer In",
  "pc.myaccount.transfer_in_amount": "Transfer In Amount",
  "pc.myaccount.transfer_out": "Transfer Out",
  "pc.myaccount.transfer_out_amount": "Transfer Out Amount",
  "pc.myaccount.transfer_to_shishibao": "Transfer to ShiShiBao",
  "pc.myaccount.usd_gift": "USD Gift",
  "pc.myaccount.user_name": "User Name",
  "pc.myaccount.verify_your_account_now": "Verify Your Account Now",
  "pc.myaccount.version_number": "Version Number",
  "pc.myaccount.you_have_not_not_verify_account": "You haven't verified your account yet",
  "pc.operate.actual_payment": "Actual Payment",
  "pc.operate.already_understand": "I Already Understand",
  "pc.operate.automatic_extension": "Automatic Extension",
  "pc.operate.automatic_renewal": "Automatic renewal",
  "pc.operate.automatically_renews_from": "automatically renewed from 2nd day",
  "pc.operate.available_balance": "Available Balance",
  "pc.operate.close_line": "Close Line",
  "pc.operate.daily_interest_rate": "Daily Interest Rate",
  "pc.operate.day": "Day",
  "pc.operate.effective_immediately": "Effective Immediately",
  "pc.operate.funding_amount": "Funding Amount",
  "pc.operate.in_total": "In Total",
  "pc.operate.insufficient_funds": "Insufficient Funds",
  "pc.operate.interest_free_explanation": "Interest-free explanation",
  "pc.operate.investment_capital": "Investment Capital",
  "pc.operate.loss_close_line": "Loss Close Line",
  "pc.operate.loss_close_line_desc": "When your total margin funds fall below the margin margin, we reserve the right to liquidate your position. To avoid liquidation, please always monitor your principal to ensure it is sufficient.",
  "pc.operate.loss_waring_line": "Loss Warning Line",
  "pc.operate.loss_warning_line_desc": "When total margin funds fall below the warning line, only positions can be closed, not opened.",
  "pc.operate.mangement_fee": "Management Fee",
  "pc.operate.margin": "Margin",
  "pc.operate.margin_funding": "Financing Funds",
  "pc.operate.margin_information": "Financing Information",
  "pc.operate.margin_trading_agreement": "The Margin Trading Agreement.",
  "pc.operate.month": "Month",
  "pc.operate.monthly_interest_rate": "Monthly Interest Rate",
  "pc.operate.pay_principal": "Pay Principal",
  "pc.operate.payment_still_due": "This payment is still due.",
  "pc.operate.read_and_agree": "I have read and agree to",
  "pc.operate.recharge_now": "Recharge now",
  "pc.operate.return_to_edit": "Return to edit",
  "pc.operate.thirty_days": "30 Days",
  "pc.operate.times": "Times",
  "pc.operate.total_margin_amount": "Total Margin Amount",
  "pc.operate.total_trading_capital": "Total Trading Capital",
  "pc.operate.trading_period": "Trading period",
  "pc.operate.trading_start_time": "Trading Start Time",
  "pc.operate.voucher": "Voucher",
  "pc.operate.warning_line": "Warning Line",
  "pc.operate.week": "Week",
  "pc.operate.weekly_interest_rate": "Weekly Interest Rate",
  "pc.operate.your_account_balance_only": "Your account balance has only",
  "pc.protocol.friend_cash_voucher_term_conditions": "Friend Cash Voucher Terms and Conditions",
  "pc.protocol.return_to_previous_page": "Return to previous page",
  "pc.putforward.please_enter_bank_card": "Please enter your bank card number",
  "pc.putforward.please_enter_withdraw_amount": "Please enter the withdrawal amount",
  "pc.putforward.please_enter_withdrawal_pw": "Please enter your withdrawal password",
  "pc.putforward.please_veryfy_real_name": "Please verify your real name first",
  "pc.putforwardmodule.please_enter_bank_card": "Please enter your bank card number",
  "pc.putforwardmodule.please_enter_withdraw_amount": "Please enter the withdrawal amount",
  "pc.putforwardmodule.please_enter_withdrawal_pw": "Please enter your withdrawal password",
  "pc.putforwardmodule.please_veryfy_real_name": "Please verify your real name first",
  "pc.quickpay.please_enter_recharge_amount": "Please enter the recharge amount in RMB",
  "pc.recharge.please_enter_bank_card": "Please enter the bank card number",
  "pc.recharge.please_enter_recharge_amount": "Please enter the recharge amount in RMB",
  "pc.recharge.please_select_bank_card": "Please select the bank card type",
  "pc.recharge_log.status1": "Waiting for review",
  "pc.recharge_log.status2": "Recharge successful",
  "pc.recharge_log.status3": "Recharge failed",
  "pc.rechargeau.enter_id_number": "Please enter your ID number",
  "pc.rechargeau.enter_real_name": "Please enter your real name",
  "pc.rechargenetpay.please_enter_recharge_amount": "Please enter the recharge amount in RMB",
  "pc.rechargenetpay2.please_enter_recharge_amount": "Please enter the recharge amount in RMB",
  "pc.rechargewx.please_enter_recharge_amount": "Please enter the recharge amount in RMB",
  "pc.register.agree_to_the_registration agreement": "Please agree to the registration agreement",
  "pc.register.create_now": "Create Now",
  "pc.register.enter_referral_code": "Please enter the referral code (optional)",
  "pc.register.enter_sms_verification_code": "Please enter the SMS verification code",
  "pc.register.enter_your_password": "Please enter your password",
  "pc.register.first_deposit": "First Deposit",
  "pc.register.free_for_new_user_registration": "Free for new user registration",
  "pc.register.gift": "Gift",
  "pc.register.i_agree": "I agree",
  "pc.register.login_to_claim": "Log in to claim",
  "pc.register.new_user_registration": "New User Registration",
  "pc.register.registration_agreement": "Registration Agreement",
  "pc.register.risk_disclosure_statement": "Risk Disclosure Statement",
  "pc.register.you_have_successfully_registered": "You have successfully registered",
  "pc.stockdetaild.pls_login": "You are not logged in yet, please log in",
  "pc.stocktrading.buy1": "Buy 1",
  "pc.stocktrading.sell1": "Sell ​​1",
  "pc.strategyHistoryDetails.buy_sell_direction": "Buy/Sell Direction",
  "pc.strategyHistoryDetails.click_to_view_fund_details": "Click to view fund details",
  "pc.strategyHistoryDetails.contract_details": "Contract Details",
  "pc.strategyHistoryDetails.deduction": "Deduction",
  "pc.strategyHistoryDetails.end_time": "End time",
  "pc.strategyHistoryDetails.freeze": "Freeze",
  "pc.strategyHistoryDetails.history_transactions": "Historical transactions",
  "pc.strategyHistoryDetails.loss_compensation": "Loss compensation",
  "pc.strategyHistoryDetails.number": "Strategy Order Number",
  "pc.strategyHistoryDetails.number_of_shares": "Number of Shares Transaction",
  "pc.strategyHistoryDetails.performance_bond_settlement": "Performance bond settlement",
  "pc.strategyHistoryDetails.profit_distribution": "Profit distribution",
  "pc.strategyHistoryDetails.settled": "Settled",
  "pc.strategyHistoryDetails.start_time": "Start time",
  "pc.strategyHistoryDetails.stock_name": "Stock Name",
  "pc.strategyHistoryDetails.strategy_capital": "Strategy Capital",
  "pc.strategyHistoryDetails.total_strategic_funds": "Total Strategic Funds",
  "pc.strategyHistoryDetails.trading_profit_loss": "Trading Profit and Loss",
  "pc.strategyHistoryDetails.trading_proft_distribution": "Trading profit distribution",
  "pc.strategyHistoryDetails.trading_type": "Trading Type",
  "pc.strategyHistoryDetails.trans_status": "Transaction Status",
  "pc.strategyHistoryDetails.unfreeze": "Unfreeze",
  "pc.strategynow.account": "Account",
  "pc.strategynow.account_management_fee": "Account Management Fee",
  "pc.strategynow.add_margin": "Add Margin",
  "pc.strategynow.add_strategy": "Add Strategy",
  "pc.strategynow.alert_triggered": "Alert Triggered",
  "pc.strategynow.all": "All",
  "pc.strategynow.applied_limit": "Applied Limit",
  "pc.strategynow.apply_for_new_margin_account": "Apply for a New Margin Account",
  "pc.strategynow.apply_for_settlement": "Apply for Settlement",
  "pc.strategynow.buy_coins": "Buy Coins",
  "pc.strategynow.completed": "Completed",
  "pc.strategynow.confirm_current_settlement_strategy": "Confirm the current settlement strategy",
  "pc.strategynow.cost": "Cost",
  "pc.strategynow.current_profit": "Current Profit",
  "pc.strategynow.current_profit_loss": "Current Profit/Loss (USD)",
  "pc.strategynow.current_total_account_balance": "Current Total Account Balance",
  "pc.strategynow.daily": "Daily",
  "pc.strategynow.financing": "Financing",
  "pc.strategynow.frozen_funds": "Frozen Funds",
  "pc.strategynow.interest_free": "Interest-Free",
  "pc.strategynow.loss_warning_line": "Loss Warning Line",
  "pc.strategynow.market_value_of_positions": "Market Value of Positions",
  "pc.strategynow.maximum_profit": "Maximum Profit",
  "pc.strategynow.monthly": "Monthly",
  "pc.strategynow.my_orders": "My Orders",
  "pc.strategynow.please_enter_additional_amount": "Please enter the additional amount",
  "pc.strategynow.please_enter_withdrawal_amount": "Please enter the withdrawal amount",
  "pc.strategynow.position_ratio": "Position Ratio",
  "pc.strategynow.profit_and_loss": "Profit and Loss",
  "pc.strategynow.profit_distribution": "Profit Distribution",
  "pc.strategynow.profit_loss": "Profit/Loss",
  "pc.strategynow.profit_loss_margin": "Profit/Loss Margin",
  "pc.strategynow.profit_withdrawal": "Profit Withdrawal",
  "pc.strategynow.risk_margin": "Risk Margin",
  "pc.strategynow.sell_coins": "Sell Coins",
  "pc.strategynow.settlement_confirmation": "Settlement Confirmation",
  "pc.strategynow.stop_loss_triggered": "Stop Loss Triggered",
  "pc.strategynow.strategy_account_balance": "Strategy Account Balance",
  "pc.strategynow.total_account_balance_after_additional_amount": "Total Account Balance after the additional amount",
  "pc.strategynow.total_contract_equity": "Total Contract Equity (USD)",
  "pc.strategynow.total_margin_funds": "Total Margin Funds",
  "pc.strategynow.weekly": "Weekly",
  "pc.sweep.please_enter_recharge_amount": "Please enter the recharge amount in RMB",
  "pc.sweep.please_select_bank": "Please select a bank",
  "pc.trading.add_to_favourite": "Add to Favourite",
  "pc.trading.amount": "Amount",
  "pc.trading.amplitude": "Amplitude",
  "pc.trading.available": "Available",
  "pc.trading.available_for_purchase": "Max Open",
  "pc.trading.available_for_sale": "Max Open",
  "pc.trading.average_price": "Average Price",
  "pc.trading.balance": "Balance",
  "pc.trading.billion": "Billion",
  "pc.trading.broker_commission": "Brokerage Commission",
  "pc.trading.business": "Business",
  "pc.trading.business_name": "Business name",
  "pc.trading.buy": "Open",
  "pc.trading.buy_and_sell": "Buy/Sell",
  "pc.trading.buy_price": "Price",
  "pc.trading.buy_volume": "Amount",
  "pc.trading.cancel_favourite": "Cancel Favourite",
  "pc.trading.cancel_order": "Cancel Order",
  "pc.trading.circulating_value": "Circulation Value",
  "pc.trading.close_short_position": "Close",
  "pc.trading.current_price": "Current Price",
  "pc.trading.date": "Date",
  "pc.trading.date_time": "Date/Time",
  "pc.trading.entrusted_query": "Entrusted Query",
  "pc.trading.entrustment": "Entrustment",
  "pc.trading.entrustment_price": "Entrustment Price",
  "pc.trading.frc_transaction": "FRC Transaction Levy",
  "pc.trading.full_position": "Max",
  "pc.trading.highest": "Highest",
  "pc.trading.limit_price": "Limit Price",
  "pc.trading.lowest": "Lowest",
  "pc.trading.lump_sum": "Lump Sum",
  "pc.trading.market": "Market",
  "pc.trading.market_buy": "Market Price",
  "pc.trading.market_price": "Market Price",
  "pc.trading.market_sell": "Market Price",
  "pc.trading.market_value": "Market Value",
  "pc.trading.operate": "Operate",
  "pc.trading.platform_fees": "Platform Fees",
  "pc.trading.please_select_an_account": "Please select an account",
  "pc.trading.position": "Position",
  "pc.trading.product_handling_fee": "Product Handling Fee",
  "pc.trading.quantity": "Quantity",
  "pc.trading.query": "Query",
  "pc.trading.sell": "Close",
  "pc.trading.sell_price": "Price",
  "pc.trading.sell_volume": "Amount",
  "pc.trading.settlement_costs": "Settlement Costs",
  "pc.trading.shares": "Shares",
  "pc.trading.short_sell": "Open",
  "pc.trading.stamp_duty": "Stamp Duty",
  "pc.trading.statement": "Statement",
  "pc.trading.status": "Status",
  "pc.trading.stock": "Stock",
  "pc.trading.stock_code": "Stock Code",
  "pc.trading.system_closing_possition": "System Closing Possition",
  "pc.trading.thousands_of_hands": "*1000hands",
  "pc.trading.time": "Time",
  "pc.trading.today_open": "Today's Open",
  "pc.trading.total_market_capitalization": "Total Market Capitalization",
  "pc.trading.total_price": "Total Price",
  "pc.trading.total_profit_and_loss": "Total Profit and Loss",
  "pc.trading.trading_amount": "Trade Amount",
  "pc.trading.trading_volume": "Volume",
  "pc.trading.transaction": "Transaction",
  "pc.trading.transaction_amount": "Transaction Amount",
  "pc.trading.transaction_price": "Transaction Price",
  "pc.trading.transaction_quantity": "Transaction Quantity",
  "pc.trading.transaction_sold_price": "Sold Price",
  "pc.trading.transactional_records": "Transactional Records",
  "pc.trading.transfer_fee": "Transfer Fee",
  "pc.trading.turnover_rate": "Turnover Rate",
  "pc.trading.type": "Type",
  "pc.trading.unit_price": "Unit Price",
  "pc.trading.yesterday_close": "Yesterday's Close",
  "pc.tradingquery.available_sell_quantity": "Available Quantity",
  "pc.tradingquery.buy_amount": "Open Trade Volume",
  "pc.tradingquery.cancellation_order_query": "Cancellation Order Query",
  "pc.tradingquery.commission": "Commission",
  "pc.tradingquery.cost_price": "Cost Price",
  "pc.tradingquery.current_price": "Current Price",
  "pc.tradingquery.frozen_quantity": "Frozen Quantity",
  "pc.tradingquery.opening_date": "Opening Date",
  "pc.tradingquery.order_date": "Order Date",
  "pc.tradingquery.order_direction": "Order Direction",
  "pc.tradingquery.order_price": "Order Price",
  "pc.tradingquery.order_quantity": "Order Quantity",
  "pc.tradingquery.order_status": "Order Status",
  "pc.tradingquery.order_time": "Order Time",
  "pc.tradingquery.platform_fee": "Platform Fee",
  "pc.tradingquery.position_query": "Position Query",
  "pc.tradingquery.profit_loss_amount": "Profit/Loss Amount",
  "pc.tradingquery.profit_loss_ratio": "Profit/Loss Ratio",
  "pc.tradingquery.sell_amount": "Sell Amount",
  "pc.tradingquery.settlement_and_settlement_fee": "Settlement and Settlement Fee",
  "pc.tradingquery.total_position": "Total Position",
  "pc.tradingquery.transaction_direction": "Transaction Direction",
  "pc.tradingquery.transaction_fee": "Transaction Fee",
  "pc.tradingquery.transaction_inquiry": "Transaction Inquiry",
  "pc.tradingquery.transaction_levy": "Transaction Levy",
  "pc.tradingquery.transaction_time": "Transaction Time",
  "pc.tradingquery.unfilled_quantity": "Unfilled Quantity",
  "pc.usercoupon.after_margin_financing_purchase_amount_reaches": "After margin financing, purchase amount reaches",
  "pc.usercoupon.cash_coupon": "Cash Coupon",
  "pc.usercoupon.get_rmb": "Get RMB",
  "pc.usercoupon.no_records_yet": "No records yet",
  "pc.usercoupon.requirements": "Requirements",
  "pc.usercoupon.withdrawal_is_available_after_rmb": "Withdrawal is available after RMB",
  "system.ActivityInfo.account_insufficient_funds": "Your account has insufficient funds",
  "system.ActivityInfo.already_experienced_free_funding": "You have already experienced free funding",
  "system.ActivityInfo.free_funding_application_failed": "Free funding application failed",
  "system.ActivityInfo.free_funding_application_success": "Free funding application successful",
  "system.AgentCreate.agent_already_opened": "Agent already opened",
  "system.AgentCreate.agent_opened_failed": "Agent opened failed",
  "system.AgentCreate.agent_opened_success": "Agent opened successful",
  "system.AgentInfo.account_balance_insufficient": "Your account balance is insufficient",
  "system.AgentInfo.amount_input_error": "Amount input error",
  "system.AgentInfo.fund_transfer_failed": "Fund transfer failed",
  "system.AgentInfo.fund_transfer_success": "Fund transfer successful",
  "system.AgentInfo.no_promotion_code_contact_service": "No promotion code, please contact customer service",
  "system.AgentInfo.transfer_amount_input_error": "Transfer amount input error",
  "system.AgentInfo.withdrawal_application_failed": "Withdrawal application failed",
  "system.AgentInfo.withdrawal_application_success": "Withdrawal application successful",
  "system.AutoClose.margin_call_fail": "Margin call failed",
  "system.AutoClose.margin_call_sucesss": "Margin call successful",
  "system.AutoClose.order_sell_fail": "Order sale failed",
  "system.AutoClose.order_sell_suceess": "Order sale successful",
  "system.AutoDepot.purchase_failed": "Purchase failed",
  "system.AutoDepot.purchase_success": "Purchase successful",
  "system.AutoDepot.sell_stock_failed": "Stock sale failed",
  "system.AutoDepot.sell_stock_success": "Stock sale successful",
  "system.Banks.account_holder_name_cannot_be_empty": "Account holder name cannot be empty",
  "system.Banks.account_holder_name_inconsistent_with_verification": "Account holder name inconsistent with verification name",
  "system.Banks.bank_branch_cannot_be_empty": "Bank branch cannot be empty",
  "system.Banks.bank_card_number_cannot_be_empty": "Bank card number cannot be empty",
  "system.Banks.bank_card_number_format_error": "Bank card number format error",
  "system.Banks.bank_name_cannot_be_empty": "Bank name cannot be empty",
  "system.Banks.bank_not_open": "This bank not yet open",
  "system.Banks.bind_failed": "Binding failed",
  "system.Banks.bind_success": "Binding successful",
  "system.Banks.first_real_name_verification_to_bind_bank_card": "First real name verification to bind bank card",
  "system.Banks.modify_failed": "Modification failed",
  "system.Banks.modify_success": "Modification successful",
  "system.CancelEntrust.batch_cancel_entrust_failed": "Batch cancel entrust failed",
  "system.CancelEntrust.batch_cancel_entrust_success": "Batch cancel entrust successful",
  "system.CancelEntrust.cancel_entrust_order_failed": "Cancel entrust order failed",
  "system.CancelEntrust.cancel_entrust_order_not_exists": "Cancel entrust order does not exist",
  "system.CancelEntrust.cancel_entrust_order_success": "Cancel entrust order successful",
  "system.CancelEntrust.cancel_order_success": "Cancel the order successfully",
  "system.CancelEntrust.entrust_order_id_not_exists": "Entrust order ID does not exist",
  "system.CancelEntrust.funding_info_not_exists": "Funding information does not exist",
  "system.CancelEntrust.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.CancelEntrust.no_entrust_info": "No entrust information",
  "system.CancelEntrust.position_info_not_exists": "Position information does not exist",
  "system.CapitalHistory.funding_unique_id_not_passed": "Funding unique ID not passed",
  "system.CapitalOperate.account_balance_insufficient": "Your account balance is insufficient",
  "system.CapitalOperate.account_balance_insufficient_exclamation": "Your account balance is insufficient!",
  "system.CapitalOperate.account_insufficient_funds": "Your account has insufficient funds",
  "system.CapitalOperate.additional_amount_format_error": "Additional amount format error",
  "system.CapitalOperate.additional_amount_must_not_less_than_0": "Additional amount must not be less than 0",
  "system.CapitalOperate.additional_funding_amount_must_be_100_multiple": "Additional funding amount must be multiple of 100",
  "system.CapitalOperate.additional_funding_amount_must_not_less_than_0": "Additional funding amount must not be less than 0",
  "system.CapitalOperate.additional_funding_failed": "Additional funding failed",
  "system.CapitalOperate.additional_funding_success": "Additional funding successful",
  "system.CapitalOperate.additional_margin_failed": "Additional margin failed",
  "system.CapitalOperate.additional_margin_success": "Additional margin successful",
  "system.CapitalOperate.free_funding_cannot_withdraw_profit": "Free funding cannot withdraw profit!",
  "system.CapitalOperate.minimum_additional_amount": "Minimum additional capital has been met",
  "system.CapitalOperate.minimum_additional_funding_amount": "Minimum additional capital reached",
  "system.CapitalOperate.please_enter_additional_amount": "Please enter additional amount",
  "system.CapitalOperate.please_enter_additional_funding_amount": "Please enter additional funding amount",
  "system.CapitalOperate.please_enter_withdrawal_amount": "Please enter withdrawal amount",
  "system.CapitalOperate.please_select_funding_order": "Please select funding order",
  "system.CapitalOperate.profit_amount_insufficient": "Insufficient profit amount",
  "system.CapitalOperate.sorry_function_not_yet_open": "Sorry, this function is not yet open!",
  "system.CapitalOperate.withdraw_profit_failed": "Withdraw profit failed",
  "system.CapitalOperate.withdraw_profit_success": "Withdraw profit successful",
  "system.CapitalOperate.withdrawal_amount_format_error": "Withdrawal amount format error",
  "system.CapitalOperate.withdrawal_amount_must_greater_than_0": "Withdrawal amount must be greater than 0",
  "system.CapitalWith.account_insufficient_funds": "Your account has insufficient funds",
  "system.CapitalWith.funding_application_failed": "Funding application failed",
  "system.CapitalWith.funding_application_success": "Funding application successful",
  "system.CapitalWith.funding_multiple_selection_error": "Funding multiple selection error",
  "system.CapitalWith.margin_must_be_100_multiple": "Margin must be multiple of 100",
  "system.CapitalWith.maximum_risk_margin": "Higher risk margin",
  "system.CapitalWith.minimum_risk_margin": "Lower risk margin",
  "system.CapitalWith.not_yet_open": "Not yet open",
  "system.CapitalWith.please_enter_risk_margin": "Please enter risk margin",
  "system.CapitalWith.please_select_funding_multiple": "Please select funding multiple",
  "system.CapitalWith.please_select_operation_type": "Please select operation type",
  "system.Capital_model.funding_info_not_exists": "Funding information does not exist",
  "system.Capital_model.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.Concern.add_to_watchlist_failed": "Add to watchlist failed",
  "system.Concern.add_to_watchlist_success": "Add to watchlist successful",
  "system.Concern.code_cannot_be_empty": "Code cannot be empty",
  "system.Concern.code_not_exists": "Code does not exist",
  "system.Concern.remove_from_watchlist_failed": "Remove from watchlist failed",
  "system.Concern.remove_from_watchlist_success": "Remove from watchlist successful",
  "system.Concern.remove_from_watchlist_success_simple": "Remove from watchlist successful",
  "system.Concern.stock_not_yet_open": "This stock is not yet open",
  "system.ExactLog.profit_withdrawal": "Profit withdrawal",
  "system.Finance.account_insufficient_funds": "Your account has insufficient funds",
  "system.Finance.delete_operation_failed": "Delete operation failed",
  "system.Finance.deleted": "Deleted",
  "system.Finance.disagree_transaction_channel": "Disagree transaction channel",
  "system.Finance.minimum_withdrawal_amount": "Need to apply for a withdrawal amount greater than the minimum",
  "system.Finance.please_bind_bank_card": "Please bind bank card",
  "system.Finance.please_enter_application_amount": "Please enter application amount",
  "system.Finance.please_enter_gxpay_id": "Please enter your GXPay ID",
  "system.Finance.please_enter_recharge_amount": "Please enter recharge amount",
  "system.Finance.please_enter_withdrawal_password": "Please enter withdrawal password",
  "system.Finance.please_select_recharge_type": "Please select recharge type",
  "system.Finance.recharge_amount_must_be_100_multiple": "Recharge amount must be multiple of 100",
  "system.Finance.recharge_amount_must_be_integer": "Recharge amount must be integer",
  "system.Finance.recharge_application_failed": "Recharge application failed",
  "system.Finance.recharge_application_success": "Recharge application successful",
  "system.Finance.recharge_confirmation": "Recharge confirmation",
  "system.Finance.recharge_confirmation_operation_failed": "Recharge confirmation operation failed",
  "system.Finance.recharge_type_selection_error": "Recharge type selection error",
  "system.Finance.withdrawal_amount_must_be_integer": "Withdrawal amount must be integer",
  "system.Finance.withdrawal_application_failed": "Withdrawal application failed",
  "system.Finance.withdrawal_application_success": "Withdrawal application successful",
  "system.Finance.withdrawal_password_input_error": "Withdrawal password input error",
  "system.Finance.withdrawal_password_not_set": "Withdrawal password not set",
  "system.FinanceDetail_model.is_repeat_no": "No",
  "system.FinanceDetail_model.is_repeat_yes": "Yes",
  "system.FinanceDetail_model.period_months_suffix": "months",
  "system.FinanceDetail_model.period_weeks_suffix": "days",
  "system.FinanceFund.account_insufficient_balance": "Account balance insufficient",
  "system.FinanceFund.fund_transfer_in_failed": "Fund transfer in failed",
  "system.FinanceFund.fund_transfer_in_success": "Fund transfer in successful",
  "system.FinanceFund.fund_transfer_out_failed": "Fund transfer out failed",
  "system.FinanceFund.fund_transfer_out_success": "Fund transfer out successful",
  "system.FinanceFund.idle_money_manager_type_not_found": "Idle money manager type not found",
  "system.FinanceFund.investable_balance_insufficient": "Insufficient investable balance",
  "system.FinanceFund.investment_fail": "Investment failure",
  "system.FinanceFund.investment_sucess": "Investment success",
  "system.FinanceFund.no_settlement_document_selected": "No settlement document selected",
  "system.FinanceFund.please_enter_amount": "Please enter amount",
  "system.FinanceFund.please_enter_correct_amount": "Please enter correct amount",
  "system.FinanceFund.please_select_idle_money_manager_type": "Please select idle money manager type",
  "system.FinanceFund.settlement_document_not_found": "Settlement document not found",
  "system.FinanceFund.settlement_failed": "Settlement failed",
  "system.FinanceFund.settlement_success": "Settlement successful",
  "system.FinanceFund.transferable_amount_insufficient": "Insufficient transferable amount",
  "system.FirstVoucher.already_signed_today_next_trading_day": "You have already signed in today, come back next trading day!",
  "system.FirstVoucher.backend_bonus": "Backend Bonus",
  "system.FirstVoucher.batch_process_cash_failed": "Batch process cash failed!",
  "system.FirstVoucher.batch_process_voucher_failed": "Batch process voucher failed!",
  "system.FirstVoucher.capital_allocate": "'s interest fee",
  "system.FirstVoucher.deposit_bonus": "Deposit Bonus",
  "system.FirstVoucher.event_bonus": "Event Bonus",
  "system.FirstVoucher.first_deposit_bonus": "First Deposit Bonus",
  "system.FirstVoucher.first_recharge_batch_process_success": "First recharge batch process successful",
  "system.FirstVoucher.first_trade_bonus": "First Transaction Bonus",
  "system.FirstVoucher.real_name_bonus": "Real-name Bonus",
  "system.FirstVoucher.sign_bonus": "Sign-up Bonus",
  "system.FirstVoucher.sign_in_bonus": "Sign-in Bonus",
  "system.FirstVoucher.signin_success_congratulations_voucher": "Sign in successful",
  "system.FirstVoucher.trial_bonus": "Trial Bonus",
  "system.FirstVoucher.voucher_bounus": "Voucher Usage",
  "system.FirstVoucher.welcome_signin_non_trading_day": "Welcome to sign in, today is a non-trading day!",
  "system.FirstVoucher.winning_bonus": "Winning Bonus",
  "system.ForgetPassword.new_password_cannot_be_empty": "New password cannot be empty",
  "system.ForgetPassword.new_password_must_be_6_to_12_digits": "New password must be 6-12 digits",
  "system.ForgetPassword.phone_number_format_incorrect": "Phone number format incorrect",
  "system.ForgetPassword.phone_number_incorrect": "Phone number incorrect",
  "system.ForgetPassword.phone_number_not_registered": "This phone number not registered",
  "system.ForgetPassword.phone_verification_code_incorrect": "Phone verification code incorrect",
  "system.ForgetPassword.please_enter_phone_verification_code": "Please enter phone verification code",
  "system.ForgetPassword.please_enter_registration_phone_number": "Please enter registration phone number",
  "system.ForgetPassword.retrieve_login_password_failed": "Retrieve login password failed",
  "system.ForgetPassword.retrieve_login_password_success": "Retrieve login password successful",
  "system.ForgetPassword.two_password_inputs_inconsistent": "Two password inputs inconsistent",
  "system.FriendCoupon.friend_voucher_generation_complete": "Friend voucher generation complete",
  "system.HolidayFund.account_insufficient_balance": "Account balance insufficient",
  "system.HolidayFund.auto_transfer_modify_success": "Auto transfer modification successful",
  "system.HolidayFund.fund_transfer_failed": "Fund transfer failed",
  "system.HolidayFund.fund_transfer_in_failed": "Fund transfer in failed",
  "system.HolidayFund.fund_transfer_in_success": "Fund transfer in successful",
  "system.HolidayFund.fund_transfer_successful": "Fund transfer successful",
  "system.HolidayFund.holiday_account_not_found": "Holiday account not found",
  "system.HolidayFund.insufficient_investable_balance": "Insufficient investable balance",
  "system.HolidayFund.insufficient_transferable_amountt": "Insufficient transferable amount",
  "system.HolidayFund.investment_failed": "Investment failed",
  "system.HolidayFund.investment_successful": "Investment successful",
  "system.HolidayFund.no_settlement_document_found": "No settlement document found",
  "system.HolidayFund.no_settlement_document_selected": "No settlement document selected",
  "system.HolidayFund.please_enter_amount": "Please enter amount",
  "system.HolidayFund.please_enter_correct_amount": "Please enter correct amount",
  "system.HolidayFund.please_select_holiday_product": "Please select holiday product",
  "system.HolidayFund.product_not_found": "Festival Treasure product not found",
  "system.HolidayFund.settlement_failed": "Settlement failed",
  "system.HolidayFund.settlement_successf": "Settlement successful",
  "system.HolidayType_model.period_days_suffix": "days",
  "system.Home.no_activity": "No activity!",
  "system.Home1.no_activity": "No activity!",
  "system.KLine.illegal_input": "Illegal input",
  "system.KLine.kline_type_not_specified": "K-line type not specified!",
  "system.KLine.stock_code_not_specified": "Stock code not specified!",
  "system.LoanLog.apply_finance": "Additional margin financing",
  "system.LoanLog.apply_margin": "Apply for margin financing",
  "system.Login.information_error": "Information error!",
  "system.Login.login_failed": "Login failed",
  "system.Login.login_success": "Login successful",
  "system.Login.no_permission": "You have no permission",
  "system.Login.phone_encryption_end": "Phone encryption end",
  "system.Login.phone_or_password_error": "Phone number or login password error",
  "system.Login.please_enter_login_password": "Please enter login password",
  "system.Login.please_enter_phone_number": "Please enter phone number",
  "system.ManageLog.management_fee": "Management Fees",
  "system.Member.agent_opened_failed": "Agent opened failed",
  "system.Member.agent_opened_success": "Agent opened successful",
  "system.Member.already_real_name_verified": "Already real name verified",
  "system.Member.confirm_password_cannot_be_empty": "Confirm password cannot be empty",
  "system.Member.contact_service_complete_real_name_verification": "Please contact customer service to complete real name verification before operating forget password.",
  "system.Member.email_format_error": "Email format error",
  "system.Member.email_verification_code_error": "Email verification code error",
  "system.Member.id_number_format_error": "ID number format error",
  "system.Member.modify_failed": "Modify failed",
  "system.Member.modify_phone_failed": "Modify phone number failed",
  "system.Member.modify_phone_success": "Modify phone number successful",
  "system.Member.modify_success": "Modify successful",
  "system.Member.new_password_must_be_6_to_12_digits": "New password must be 6-12 digits",
  "system.Member.nickname_modify_failed": "Nickname modification failed",
  "system.Member.nickname_modify_success": "Nickname modification successful",
  "system.Member.operation_failed": "Operation failed",
  "system.Member.operation_success": "Operation successful",
  "system.Member.phone_number_format_error": "Phone number format error",
  "system.Member.phone_verification_code_error": "Phone verification code error",
  "system.Member.please_contact_service": "Please contact customer service",
  "system.Member.please_enter_email": "Please enter email",
  "system.Member.please_enter_email_verification_code": "Please enter email verification code",
  "system.Member.please_enter_id_number": "Please enter ID number",
  "system.Member.please_enter_new_password": "Please enter new password",
  "system.Member.please_enter_nickname": "Please enter nickname",
  "system.Member.please_enter_phone_number": "Please enter phone number",
  "system.Member.please_enter_phone_verification_code": "Please enter phone verification code",
  "system.Member.please_enter_real_name": "Please enter real name",
  "system.Member.real_name_format_error": "Real name format error",
  "system.Member.real_name_verification_application_failed": "Real name verification application failed",
  "system.Member.real_name_verification_application_success": "Real name verification application successful",
  "system.Member.two_password_inputs_inconsistent": "Two password inputs inconsistent",
  "system.Member.user_already_used": "This user already used",
  "system.Member.verification": "Verification",
  "system.NewsCenter.news_not_found": "News not found",
  "system.NewsCenter.please_pass_news_unique_id": "Please pass news unique ID",
  "system.Notice_model.date_format": "Y年m月d日",
  "system.Nozzle.abnormal_login_please_relogin": "Abnormal login, please login again",
  "system.Nozzle.data_normal": "Data normal",
  "system.Nozzle.login_timeout_please_relogin": "Login timeout, please login again",
  "system.Offline.disagree_transaction_channel": "Disagree transaction channel",
  "system.Offline.fast_channel_temporarily_closed_contact_service": "Fast channel temporarily closed, please contact online customer service",
  "system.Offline.order_failed_large_amount_contact_service": "Order failed, large amount please contact online customer service",
  "system.Offline.please_contact_online_service": "Please contact online customer service",
  "system.Offline.please_do_not_frequent_operation_wait_3min": "Please do not frequent operation, wait 3 minutes before trying again",
  "system.Offline.please_enter_recharge_amount": "Please enter recharge amount",
  "system.Offline.please_go_real_name_verification": "Please go for real name verification",
  "system.Offline.please_select_fixed_amount": "Please select fixed amount",
  "system.Offline.please_select_recharge_type": "Please select recharge type",
  "system.Offline.recharge_amount_must_be_100_multiple": "Recharge amount must be multiple of 100",
  "system.Offline.recharge_amount_must_be_integer": "Recharge amount must be integer",
  "system.Offline.recharge_amount_must_be_over_100": "Recharge amount must be over 100",
  "system.Offline.recharge_application_failed": "Recharge application failed",
  "system.Offline.recharge_application_success_contact_service": "Recharge application successful, complete follow-up operations quickly, contact customer service",
  "system.Offline.recharge_type_selection_error": "Recharge type selection error",
  "system.PayBasic.recharge_application_failed": "Recharge application failed",
  "system.PayBasic.recharge_application_success": "Recharge application successful",
  "system.PayFive.abnormal_login_please_relogin": "Abnormal login, please login again",
  "system.PayFive.application_failed": "Application failed",
  "system.PayFive.application_success": "Application successful",
  "system.PayFive.bank_card_format_error": "Bank card number format error",
  "system.PayFive.login_timeout_please_relogin": "Login timeout, please login again",
  "system.PayFive.payment_bank_not_open": "Payment bank not yet open",
  "system.PayFive.please_enter_recharge_amount": "Please enter recharge amount",
  "system.PayFive.please_select_payment_bank": "Please select payment bank",
  "system.PayFive.please_select_payment_bank_card": "Please select payment bank card number",
  "system.PayFive.quick_pay_minimum_20_yuan": "Quick pay minimum recharge 20 yuan",
  "system.PayOne.abnormal_login_please_relogin": "Abnormal login, please login again",
  "system.PayOne.login_timeout_please_relogin": "Login timeout, please login again",
  "system.PayOne.please_bind_bank_card": "Please bind bank card",
  "system.PayOne.please_enter_recharge_amount": "Please enter recharge amount",
  "system.PayOne.please_real_name_verification": "Please real name verification",
  "system.PayOne.recharge_application_failed": "Recharge application failed",
  "system.PayOne.recharge_application_success": "Recharge application successful",
  "system.PhoneCode.enter_registration_phone_number": "Enter registration phone number",
  "system.PhoneCode.name_or_id_number_error": "The name or ID number you entered is incorrect",
  "system.PhoneCode.phone_number_already_registered": "Phone number already registered",
  "system.PhoneCode.phone_number_format_incorrect": "Phone number format incorrect",
  "system.PhoneCode.phone_number_not_registered": "Phone number not registered",
  "system.PhoneCode.please_enter_correct_captcha": "Please enter correct captcha",
  "system.PhoneCode.please_try_again_later": "Please try again later",
  "system.PhoneCode.send_failed": "Send failed",
  "system.PhoneCode.type_error": "Type error",
  "system.PhoneCode.verification_code_sent_success": "Your verification code sent successfully, please check",
  "system.PhoneCode.verification_code_valid_5min_too_frequent": "Verification code valid for 5 minutes, you sent too frequently, please try later",
  "system.Protocols.please_enter_protocol_unique_id": "Please enter protocol unique ID",
  "system.RealCancelEntrust.batch_cancel_entrust_failed": "Batch cancel entrust failed",
  "system.RealCancelEntrust.batch_cancel_entrust_success": "Batch cancel entrust successful",
  "system.RealCancelEntrust.cancel_entrust_order_failed": "Cancel entrust order failed",
  "system.RealCancelEntrust.cancel_entrust_order_not_exists": "Cancel entrust order does not exist",
  "system.RealCancelEntrust.cancel_entrust_order_success": "Cancel entrust order successful",
  "system.RealCancelEntrust.entrust_order_id_not_exists": "Entrust order ID does not exist",
  "system.RealCancelEntrust.funding_info_not_exists": "Funding information does not exist",
  "system.RealCancelEntrust.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.RealCancelEntrust.no_entrust_info": "No entrust information",
  "system.RealCancelEntrust.position_info_not_exists": "Position information does not exist",
  "system.RealCapitalHistory.funding_unique_id_not_passed": "Funding unique ID not passed",
  "system.RealCapitalOperate.account_balance_insufficient": "Your account balance is insufficient",
  "system.RealCapitalOperate.account_balance_insufficient_exclamation": "Your account balance is insufficient!",
  "system.RealCapitalOperate.additional_amount_format_error": "Additional amount format error",
  "system.RealCapitalOperate.additional_amount_must_not_less_than_0": "Additional amount must not be less than 0",
  "system.RealCapitalOperate.additional_funding_amount_must_be_100_multiple": "Additional funding amount must be multiple of 100",
  "system.RealCapitalOperate.additional_funding_amount_must_not_less_than_0": "Additional funding amount must not be less than 0",
  "system.RealCapitalOperate.additional_funding_failed": "Additional funding failed",
  "system.RealCapitalOperate.additional_funding_success": "Additional funding successful",
  "system.RealCapitalOperate.additional_margin_failed": "Additional margin failed",
  "system.RealCapitalOperate.additional_margin_success": "Additional margin successful",
  "system.RealCapitalOperate.free_funding_cannot_withdraw_profit": "Free funding cannot withdraw profit!",
  "system.RealCapitalOperate.minimum_additional_amount": "Minimum additional amount {amount} yuan",
  "system.RealCapitalOperate.minimum_additional_funding_amount": "Minimum additional funding amount {amount} yuan",
  "system.RealCapitalOperate.please_enter_additional_amount": "Please enter additional amount",
  "system.RealCapitalOperate.please_enter_additional_funding_amount": "Please enter additional funding amount",
  "system.RealCapitalOperate.please_enter_withdrawal_amount": "Please enter withdrawal amount",
  "system.RealCapitalOperate.please_select_funding_order": "Please select funding order",
  "system.RealCapitalOperate.profit_amount_insufficient": "Insufficient profit amount",
  "system.RealCapitalOperate.withdraw_profit_failed": "Withdraw profit failed",
  "system.RealCapitalOperate.withdraw_profit_success": "Withdraw profit successful",
  "system.RealCapitalOperate.withdrawal_amount_format_error": "Withdrawal amount format error",
  "system.RealCapitalOperate.withdrawal_amount_must_greater_than_0": "Withdrawal amount must be greater than 0",
  "system.RealCapitalWith.account_insufficient_funds": "Your account has insufficient funds",
  "system.RealCapitalWith.funding_application_failed": "Funding application failed",
  "system.RealCapitalWith.funding_application_success": "Funding application successful",
  "system.RealCapitalWith.funding_multiple_selection_error": "Funding multiple selection error",
  "system.RealCapitalWith.margin_must_be_100_multiple": "Margin must be multiple of 100",
  "system.RealCapitalWith.maximum_risk_margin": "Maximum risk margin {amount}",
  "system.RealCapitalWith.minimum_risk_margin": "Minimum risk margin {amount}",
  "system.RealCapitalWith.not_yet_open": "Not yet open",
  "system.RealCapitalWith.please_enter_risk_margin": "Please enter risk margin",
  "system.RealCapitalWith.please_select_funding_multiple": "Please select funding multiple",
  "system.RealCapitalWith.please_select_operation_type": "Please select operation type",
  "system.RealCapital_model.funding_info_not_exists": "Funding information does not exist",
  "system.RealCapital_model.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.RealDeal_model.market_price_prefix": "Market Price",
  "system.RealDeal_model.type_buy": "Buy",
  "system.RealDeal_model.type_sell": "Sell",
  "system.RealEntrust_model.status_cancelled": "Cancelled",
  "system.RealSettlement.entrust_orders_unprocessed_cannot_settle": "You have unprocessed entrust orders, cannot settle temporarily",
  "system.RealSettlement.funding_settlement_failed": "Funding settlement failed",
  "system.RealSettlement.funding_settlement_success": "Funding settlement successful",
  "system.RealSettlement.position_orders_unprocessed_cannot_settle": "You have unprocessed position orders, cannot settle temporarily",
  "system.RealSettlement.settlement_cycle_minimum_two_days": "Settlement cycle minimum is two days",
  "system.RealTradeBuy.buy_price_format_error": "Buy price format error",
  "system.RealTradeBuy.buy_quantity_cannot_be_empty": "Buy quantity cannot be empty",
  "system.RealTradeBuy.buy_quantity_format_error": "Buy quantity format error",
  "system.RealTradeBuy.buy_quantity_must_be_100_multiple": "Buy quantity must be multiple of 100",
  "system.RealTradeBuy.entrust_failed": "Entrust failed",
  "system.RealTradeBuy.entrust_success": "Entrust successful",
  "system.RealTradeBuy.funding_account_insufficient_funds": "Your funding account has insufficient funds",
  "system.RealTradeBuy.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.RealTradeBuy.please_enter_stock_code": "Please enter stock code",
  "system.RealTradeBuy.purchase_failed": "Purchase failed",
  "system.RealTradeBuy.selected_funding_info_not_exists": "Selected funding information does not exist",
  "system.RealTradeSell.entrust_failed": "Entrust failed",
  "system.RealTradeSell.entrust_success": "Entrust successful",
  "system.RealTradeSell.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.RealTradeSell.please_enter_sell_quantity": "Please enter sell quantity",
  "system.RealTradeSell.please_enter_stock_code": "Please enter stock code",
  "system.RealTradeSell.position_info_not_exists": "Position information does not exist",
  "system.RealTradeSell.selected_funding_info_not_exists": "Selected funding information does not exist",
  "system.RealTradeSell.sell_price_format_error": "Sell price format error",
  "system.RealTradeSell.sell_quantity_format_error": "Sell quantity format error",
  "system.RealTradeSell.sell_quantity_must_greater_than_100": "Sell quantity must be greater than 100",
  "system.RealTradeSell.sell_stock_failed": "Sell stock failed",
  "system.RealTradeSell.sell_stock_success": "Sell stock successful",
  "system.RealTradeSell.stock_limit_down_trading_prohibited": "Stock limit down trading prohibited",
  "system.RealTradeSell.stock_temporarily_unavailable": "Stock temporarily unavailable for trading",
  "system.RealTradeSell.stock_today_trading_restricted": "This stock has restricted trading today",
  "system.RealTradeSell.today_tradeable_quantity_insufficient": "Insufficient tradeable quantity today",
  "system.Recharge_model.operation_failed": "Operation failed",
  "system.Recharge_model.operation_success": "Operation successful",
  "system.Recharge_model.third_party_updated_confirmation": "Please confirm if a third party has already made updates!",
  "system.RecommendShare.parameter_value_invalid": "Parameter value invalid",
  "system.RecommendShare.please_enter_category": "Please enter category",
  "system.RecommendShare.recharge_insufficient": "Insufficient recharge",
  "system.Register.cash_voucher_already_used": "Cash voucher already used",
  "system.Register.cash_voucher_unavailable": "Cash voucher unavailable",
  "system.Register.login_password_format_error": "Login password must be 6-12 letters + numbers",
  "system.Register.phone_number_already_registered": "Phone number already registered",
  "system.Register.phone_number_format_error": "Phone number format error",
  "system.Register.phone_number_mismatch": "Phone number and received phone number do not match",
  "system.Register.phone_verification_code_error": "Phone verification code error",
  "system.Register.please_enter_login_password": "Please enter login password",
  "system.Register.please_enter_phone_number": "Please enter phone number",
  "system.Register.please_enter_phone_verification_code": "Please enter phone verification code",
  "system.Register.registration_failed": "Registration failed",
  "system.Register.registration_success": "Registration successful",
  "system.RiskControls.approching_warning_line": "Yuan, approaching the warning line",
  "system.RiskControls.away_from_liquidation_line": "Yuan, away from the liquidation line",
  "system.RiskControls.close_the_possition_balance": "Close position.Balance",
  "system.RiskControls.close_to_the_liquidation": "Close to the liquidation threshold",
  "system.RiskControls.contract_balance": "Contract balance",
  "system.RiskControls.current_market_capitalization": "Yuan, current market capitalization",
  "system.RiskControls.dear_customer_your_account": "Dear Customer, Your account",
  "system.RiskControls.dear_customer_your_contract_number": "Dear Customer, Your Contract Number",
  "system.RiskControls.gem_star_board_position_ratio_limit": "GEM or STAR board single stock position ratio cannot exceed 100%",
  "system.RiskControls.individual_stock_position_exceeds_limit": "Individual stock cumulative position exceeds limit",
  "system.RiskControls.insufficient_funds": "Insufficient funds",
  "system.RiskControls.loan_amount": "Loan amount",
  "system.RiskControls.loss_exceeds_warning_line_trading_prohibited": "Loss exceeds warning line, trading prohibited",
  "system.RiskControls.margin": "Yuan, Margin",
  "system.RiskControls.margin_call_required": "Yuan, margin call required",
  "system.RiskControls.max_min_price_limit_exceeded": "Maximum/minimum price limit exceeded (9 times or 1/9 of closing price)",
  "system.RiskControls.maximum_price_trading_restricted": "Maximum price trading restricted",
  "system.RiskControls.member_account": "Member Account",
  "system.RiskControls.please_recharge_your_margin_to_avoid_losses": "Please promptly top up your margin to avoid losses resulting from the system automatically closing your positions.",
  "system.RiskControls.position_info_not_exists": "Position information does not exist",
  "system.RiskControls.profit_loss": "Yuan, profit and loss",
  "system.RiskControls.right_to_close_positions_our_discretion": "In accordance with the contractual terms, we reserve the right to close positions at our discretion. Please monitor developments promptly.",
  "system.RiskControls.stock_accumulated_over_50million_prohibited": "Stock accumulated over 50 million, trading prohibited",
  "system.RiskControls.stock_not_open_for_trading": "This stock is not yet open for trading",
  "system.RiskControls.stock_temporarily_prohibited_contact_service": "This stock temporarily prohibited, please contact customer service",
  "system.RiskControls.stock_today_trading_restricted": "This stock has restricted trading today",
  "system.RiskControls.stock_trading_prohibited": "This stock trading prohibited",
  "system.RiskControls.subject_to_contract_termination": "Dear Customer, Your account is currently in arrears and will be subject to contract termination",
  "system.RiskControls.suspended_stock_trading_prohibited": "Suspended stock trading prohibited",
  "system.RiskControls.system_has_closed_and_settled": "The position has expired, and the system has closed and settled it in accordance with the agreed terms.",
  "system.RiskControls.today_tradeable_quantity_insufficient": "Insufficient tradeable quantity today",
  "system.RiskControls.with_losses_exceeding": "Yuan, with losses exceeding",
  "system.RiskControls.yuan": "Yuan",
  "system.Settlement.entrust_orders_unprocessed_cannot_settle": "You have unprocessed entrust orders, cannot settle temporarily",
  "system.Settlement.funding_settlement_failed": "Funding settlement failed",
  "system.Settlement.funding_settlement_success": "Funding settlement successful",
  "system.Settlement.position_orders_unprocessed_cannot_settle": "You have unprocessed position orders, cannot settle temporarily",
  "system.StockPrice.no_candlestick_type": "No candlestick type specified!",
  "system.StockPrice.no_symbol": "No stock symbol specified!",
  "system.Stocks.current_stock_market_closed_cannot_trade": "Current stock market closed, cannot trade",
  "system.Stocks.current_stock_trading_prohibited": "Current stock trading prohibited",
  "system.Stocks.please_enter_correct_code": "Please enter correct code",
  "system.Test.abnormal_login_please_relogin": "Abnormal login, please login again",
  "system.Test.data_normal": "Data normal",
  "system.Test.login_timeout_please_relogin": "Login timeout, please login again",
  "system.TimebaoFund.account_insufficient_balance": "Account balance insufficient",
  "system.TimebaoFund.account_not_found": "Timebao account not found",
  "system.TimebaoFund.fund_transfer_in_failed": "Fund transfer in failed",
  "system.TimebaoFund.fund_transfer_in_success": "Fund transfer in successful",
  "system.TimebaoFund.fund_transfer_out_failed": "Fund transfer out failed",
  "system.TimebaoFund.fund_transfer_out_success": "Fund transfer out successful",
  "system.TimebaoFund.initialize_valid_principal": "Initialize valid principal",
  "system.TimebaoFund.interest_calculation_failed": "Interest calculation failed",
  "system.TimebaoFund.interest_calculation_success": "Interest calculation successful",
  "system.TimebaoFund.modify_success": "Modification successful",
  "system.TimebaoFund.no_balance": "No balance",
  "system.TimebaoFund.no_interest": "No interest",
  "system.TimebaoFund.please_enter_amount": "Please enter amount",
  "system.TimebaoFund.please_enter_correct_amount": "Please enter correct amount",
  "system.TimebaoFund.transferable_amount_insufficient": "Insufficient transferable amount",
  "system.TimebaoFund.user_interest_already_calculated": "User interest already calculated",
  "system.TradeBuy.account_abnormal_contact_service": "Account abnormal, please contact customer service",
  "system.TradeBuy.account_expired_buy_prohibited": "Account expired, buying prohibited",
  "system.TradeBuy.buy_price_error": "Buy price error",
  "system.TradeBuy.buy_price_format_error": "Buy price format error",
  "system.TradeBuy.buy_quantity_cannot_be_empty": "Buy quantity cannot be empty",
  "system.TradeBuy.buy_quantity_format_error": "Buy quantity format error",
  "system.TradeBuy.entrust_failed": "Entrust failed",
  "system.TradeBuy.entrust_success": "Entrust successful",
  "system.TradeBuy.funding_account_insufficient_funds": "Your funding account has insufficient funds",
  "system.TradeBuy.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.TradeBuy.market_closed_cannot_trade": "Market closed, cannot trade",
  "system.TradeBuy.minimum_buy_amount_limit": "Minimum buy amount is ({amount}) HKD",
  "system.TradeBuy.please_enter_stock_code": "Please enter stock code",
  "system.TradeBuy.please_enter_trade_quantity": "Please enter trade quantity",
  "system.TradeBuy.purchase_failed": "Purchase failed",
  "system.TradeBuy.purchase_success": "Purchase successful",
  "system.TradeBuy.stock_trading_suspended": "This stock trading is suspended",
  "system.TradeSell.account_abnormal_contact_service": "Account abnormal, please contact customer service",
  "system.TradeSell.entrust_failed": "Entrust failed",
  "system.TradeSell.entrust_success": "Entrust successful",
  "system.TradeSell.funding_unique_id_not_exists": "Funding unique ID does not exist",
  "system.TradeSell.individual_stock_position_exceeds_limit": "Individual stock cumulative position exceeds limit",
  "system.TradeSell.loss_exceeds_warning_line_trading_prohibited": "Loss exceeds warning line, trading prohibited",
  "system.TradeSell.market_closed_cannot_trade": "Market closed, cannot trade",
  "system.TradeSell.max_min_price_limit_exceeded": "Maximum/minimum price limit exceeded (9 times or 1/9 of closing price)",
  "system.TradeSell.please_enter_sell_quantity": "Please enter sell quantity",
  "system.TradeSell.please_enter_stock_code": "Please enter stock code",
  "system.TradeSell.please_enter_trade_quantity": "Please enter trade quantity",
  "system.TradeSell.position_info_not_exists": "Position information does not exist",
  "system.TradeSell.purchase_failed": "Purchase failed",
  "system.TradeSell.sell_price_format_error": "Sell price format error",
  "system.TradeSell.sell_quantity_format_error": "Sell quantity format error",
  "system.TradeSell.sell_stock_failed": "Sell stock failed",
  "system.TradeSell.sell_stock_success": "Sell stock successful",
  "system.TradeSell.stock_not_open_for_trading": "This stock is not yet open for trading",
  "system.TradeSell.stock_temporarily_unavailable": "Stock temporarily unavailable for trading",
  "system.TradeSell.stock_today_trading_restricted": "This stock has restricted trading today",
  "system.TradeSell.stock_trading_suspended": "This stock trading is suspended",
  "system.TradeSell.today_tradeable_quantity_insufficient": "Insufficient tradeable quantity today",
  "system.WebNozzle.android_download": "Android download",
  "system.WebNozzle.apple_android_download": "Apple/Android download",
  "system.WebNozzle.ios_download": "iOS download",
  "system.WebNozzle.wechat_official_account": "Follow our WeChat Official Account",
  "system.WebNozzle.wechat_subscription_account": "Follow our WeChat subscription account",
  "system.Withdraw_model.fund_withdrawal": "Fund Withdrawal",
  "system.Withdraw_model.status_completed": "Completed",
  "system.Withdraw_model.status_rejected": "Rejected",
  "system.Withdraw_model.status_under_review": "Under Review",
  "system.YuebaoFund.account_insufficient_balance": "Account balance insufficient",
  "system.YuebaoFund.account_not_found": "Yuebao account not found",
  "system.YuebaoFund.fund_transfer_in_failed": "Fund transfer in failed",
  "system.YuebaoFund.fund_transfer_in_success": "Fund transfer in successful",
  "system.YuebaoFund.fund_transfer_out_failed": "Fund transfer out failed",
  "system.YuebaoFund.fund_transfer_out_success": "Fund transfer out successful",
  "system.YuebaoFund.investment_balance_insufficient": "Insufficient investable balance",
  "system.YuebaoFund.modify_success": "Modification successful",
  "system.YuebaoFund.no_settlement_document_selected": "No settlement document selected",
  "system.YuebaoFund.please_enter_amount": "Please enter amount",
  "system.YuebaoFund.please_enter_correct_amount": "Please enter correct amount",
  "system.YuebaoFund.settlement_document_not_found": "Settlement document not found",
  "system.YuebaoFund.settlement_failed": "Settlement failed",
  "system.YuebaoFund.settlement_success": "Settlement successful",
  "system.YuebaoFund.transferable_amount_insufficient": "Insufficient transferable amount",
  "system.YuebaoFund.transferred_to_yuebao_failed": "Failed to transfer to Yuebao wealth management",
  "system.YuebaoFund.transferred_to_yuebao_success": "Successfully transferred to Yuebao wealth management",
  "pc.trading.you_have_not_selected_quantity_for_sale": "You have not selected a quantity for sale",
  "pc.trading.you_have_not_selected_any_stocks": "You have not selected any stocks",
  "pc.trading.confirm_transaction": "Confirm Transaction",
  "pc.trading.are_you_sure_sell_this_stock": "Are you sure you wish to sell this stock?",
  "pc.trading.sale_and_puchase_cancelled": "Sale and purchase cancelled",
  "pc.trading.you_have_not_selected_quantity_to_purchase": "You have not selected a quantity to purchase",
  "pc.trading.are_you_sure_purchase_this_stock": "Are you certain you wish to purchase this stock?",
  "pc.trading.purchase_has_been_cancelled": "The purchase has been cancelled",
  "pc.trading.you_have_not_logged_in_please_login_before_purchase": "You have not logged in. Please log in before proceeding with your purchase",
  "pc.trading.you_have_not_logged_in_please_login_before_sale": "You have not logged in. Please log in before proceeding with the sale",
  "pc.trading.stock_has_not_purchased_please_buy_this_stock": "This stock has not yet been purchased. Please proceed to the purchase page to buy this stock",
  "pc.operate.day_explain": "Minimum 1,000, maximum 2,000,000, multiples of 100",
  "pc.operate.week_explain": "Minimum 1,000, maximum 2,000,000, multiples of 100",
  "pc.operate.month_explain": "Minimum 1,000, maximum 2,000,000, multiples of 100",
  "pc.operate.interest_free_explain": "Minimum 1,000, maximum 2,000,000, multiples of 100",
  "pc.operate.vip_explain": "Minimum 100,000, maximum 20 million, multiples of 100",
  "pc.news_details.latest_articles": "Latest Articles",
  "pc.news_details.previous_item": "Previous Item",
  "pc.news_details.next_item": "Next item",
  "system.Member.please_contact_service_to_obtain_your_card_number": "Please contact our online customer service to obtain your card number.",
  "system.Offline.success": "Success",
  "pc.capital.contact_our_online_customer_service": "Contact our online customer service",
  "pc.capital.recharge.recharge_has_popup_confirm_button": "Continue new recharge",
  "pc.capital.recharge.recharge_has_popup_cancel_button": "Not new recharge",
  "pc.capital.topuptransit.success_popup": "Please confirm that you have paid! Repeated submission will affect the arrival time",
  "pc.capital.select_recharge_method": "Please select the recharge method",
  "pc.capital.withdraw_has_popup_content": "You have submitted a withdrawal of the same amount and it is under review. If it is not a new withdrawal, please do not submit it again.",
  "pc.capital.withdraw.withdraw_has_popup_confirm_button\t": "Continue new withdrawals",
  "pc.capital.withdraw.withdraw_has_popup_cancel_button": "Non-new withdrawals",
  "pc.couponinfo.user_coupon.fail_message": "Please try again later, Prompt",
  "pc.operate.margin_trading_rules": "Margin Trading Rules",
  "pc.timebao.first_page": "Already on the first page",
  "pc.timebao.last_page": "This is the last page",
  "pc.table.no_data": "No data yet",
  "el.select.noData": "No data",
  "el.table.emptyText": "No data yet",
  "el.select.loading": "Loading",
  "pc.allhkstock.totalMarketValue": "Total Market Value (Trillion)",
  "pc.allhkstock.tradingVolume": "Trading Volume (Million)",
  "pc.allhkstock.sort_chg_desc": "Top Gainers",
  "pc.allhkstock.sort_chg_asc": "Top Losers",
  "pc.allhkstock.sort_market_value_desc": "Market Cap",
  "pc.allhkstock.sort_volume_desc": "24h Volume",
  "pc.myaccount.platform_transfer": "Fund transfer",
  "pc.platformtransfer.dnzq": "Taurus Securities",
  "pc.platformtransfer.dnhk": "Taurus Hong Kong Stocks",
  "pc.platformtransfer.transfer_to": "Transfer to",
  "pc.platformtransfer.currency": "USD",
  "pc.platformtransfer.order_number": "Order Number",
  "pc.platformtransfer.central_system_number": "Central System Number",
  "pc.platformtransfer.transfer_amount": "Transfer Amount",
  "pc.platformtransfer.account_balance": "Account Balance",
  "pc.platformtransfer.transfer_operation_type": "Transfer Operation Type",
  "pc.platformtransfer.accessed_platform": "Accessed Platform",
  "pc.platformtransfer.create_time": "Creation Time",
  "system.platformtransfer.central_config": "Central configuration is now disabled. Please contact customer service.",
  "system.platformtransfer.only_two_decimals": "Only 2 decimal places are allowed.",
  "pc.trading.short_sell_close_position": "Close Short",
  "pc.trading.short_selling": "Open Short",
  "pc.trading.can_be_purchase": "Max Close",
  "pc.trading.open_long_possition": "Open Long",
  "pc.trading.closing_long_possition": "Close Long",
  "pc.trading.can_be_close": "Max Close",
  "pc.trading.market_open": "Market open",
  "pc.trading.market_close": "Market closed",
  "pc.header.capital_accounts": "Capital Accounts",
  "pc.cuc.amount_received": "Amount Received",
  "pc.cuc.dn_currency": "¥",
  "pc.cuc.hk_currency": "HK dollar",
  "pc.allhkstock.short_trading_stocks": "Today Short Tickers",
  "pc.allhkstock.long_trading_stocks": "Today Long Tickers",
  "system.RiskControls.system_is_busy": "The system is currently busy, please try again later",
  "system.TradeSell.stock_transaction_failed": "The stock transaction failed",
  "system.platformtransfer.transfer_failed_account_holder_not_match": "The transfer failed because the account holder information did not match.",
  "pc.tradingquery.trade_direction": "Position Direction",
  "pc.operate.direction_capital": "Capital Direction",
  "pc.operate.long": "Long Trading",
  "pc.operate.short": "Short Trading",
  "pc.stockrise.currency": "billion usd",
  "pc.trading.trading_activity_fee": "Trading Activity Fee",
  "pc.trading.direction": "Direction",
  "pc.trading.order": "Order",
  "pc.trading.open_position": "Position",
  "system.TradeBuy.daily_limit_open_error": "This sub-account has reached the daily limit for opening positions",
  "system.TradeBuy.single_stock_ratio_error": "It has exceeded the holding ratio of a single stock",
  "pc.quotes.stock_rise1": "Dow Jones",
  "pc.quotes.stock_rise2": "S&P 500",
  "pc.quotes.stock_rise3": "NASDAQ",
  "pc.trading.stock_cannot_be_traded": "This stock cannot be traded on this platform"
}


// WEBPACK FOOTER //
// ./src/assets/language/en.js